import { MeasurementType, measurementTypesLabelKey } from '@/services/device-measurements'
import type { MapCoords, MapLocation, MapSettings } from './types'

const localStorage = window.localStorage

export const measurementTypes = {
  pm25: 0,
  pm10: 1
} as const

export const measurementTypeNames = {
  [measurementTypes.pm25]: 'PM 2.5',
  [measurementTypes.pm10]: 'PM 10'
} as const

export const aqiTypes = {
  us: 0,
  in: 1
} as const

export const aqiTypeKeys = {
  [aqiTypes.us]: 'us',
  [aqiTypes.in]: 'in'
} as const

export const defaultMapSettings: Readonly<MapSettings> = {
  showMine: true,
  showPublic: true,
  showShared: true,
  showIndoor: true,
  showOutdoor: true,
  pinMeasurementType: measurementTypes.pm25,
  pinAqiType: aqiTypes.us,
  deviceModels: null
} as const

export const defaultMapLocation: Readonly<MapLocation> = {
  center: { lat: 30, lng: -87 },
  zoom: 5,
  lastZoom: 5
} as const

export function getMapSettingsObject(): MapSettings {
  const settings: MapSettings | null = JSON.parse(localStorage.getItem('tsi.mapSettings') ?? 'null')
  if (settings && settings.pinMeasurementType === undefined) {
    settings.pinMeasurementType = defaultMapSettings.pinMeasurementType
  }
  if (settings && settings.pinAqiType === undefined) {
    settings.pinAqiType = defaultMapSettings.pinAqiType
  }
  if (settings && settings.deviceModels === undefined) {
    settings.deviceModels = defaultMapSettings.deviceModels
  }
  return settings ?? { ...defaultMapSettings }
}

export function getMapLocationObject(): MapLocation {
  const oldKey = 'lastLocation'
  const key = 'tsi.mapLocation'
  const oldSettings: MapCoords | null = JSON.parse(localStorage.getItem(oldKey) ?? 'null')
  if (oldSettings !== null) {
    const mapLocation: MapLocation = { ...defaultMapLocation }
    mapLocation.center = oldSettings
    localStorage.setItem(key, JSON.stringify(mapLocation))
    localStorage.removeItem(oldKey)
    return mapLocation
  } else {
    const settings: MapLocation | null = JSON.parse(localStorage.getItem(key) ?? 'null')
    return settings ?? { ...defaultMapLocation }
  }
}

const indiaAqiMap: Readonly<Partial<Record<MeasurementType, MeasurementType>>> = {
  [MeasurementType.Pm25]: MeasurementType.Pm25IndiaAqi,
  [MeasurementType.Pm10]: MeasurementType.Pm10IndiaAqi
} as const

export const aqiMeasurementTypes: Readonly<number[]> = [
  MeasurementType.Pm25,
  MeasurementType.Pm10,
  MeasurementType.Pm25IndiaAqi,
  MeasurementType.Pm10IndiaAqi
] as const

export const getEffectiveMeasurement = (
  baseType: MeasurementType,
  aqiType: number
): MeasurementType => {
  if (aqiType === aqiTypes.in && indiaAqiMap[baseType] !== undefined) {
    return indiaAqiMap[baseType]
  }
  return baseType
}

export const getMeasurementLabelKeyForAqi = (measurement: number, aqiType: number): string => {
  const effective = getEffectiveMeasurement(measurement, aqiType)
  return measurementTypesLabelKey[effective]
}
